import { makeAutoObservable } from 'mobx'
import { apiService } from '@/services/Api'
import { SidebarState } from '@/services/Api/generated'

export class NavigationStore {
  loaded = false
  setLoaded(value: boolean) {
    this.loaded = value
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  counts: SidebarState = {
    applicationsCount: 0,
    applications: {
      applications: 0,
      applicationsByType: {
        renewal: 0,
        trademarkApplications: 0,
      },
    },
    registriesCount: {
      registries: 0,
      registriesByType: {
        tmApplication: 0,
      },
    },
    monitoringCount: 0,
  }

  setCounts(counts: SidebarState) {
    this.counts = counts
  }

  setApplicationsCount(count: number) {
    this.counts.applicationsCount = count
  }

  setRegistries(count: number) {
    this.counts.registriesCount.registries = count
  }

  setRegistriesTMApplicaiton(count: number) {
    this.counts.registriesCount.registriesByType.tmApplication = count
  }

  async getCounts() {
    this.setLoaded(true)

    try {
      const response = await apiService.general.getSidebarState()

      if (response.status) {
        this.setCounts(response.data)
      }
    } catch {
    } finally {
      this.setLoaded(false)
    }
  }
}
